import { CbhIcon, mergeSxProps } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time. See https://www.notion.so/BP-Date-Time-2ef8643321f48032ad80e8a5b30aa278 for more information
import { format } from "date-fns";
import { type ForwardedRef, forwardRef } from "react";

import { CalendarCell, type CalendarCellProps } from "../../../Calendar/CalendarCell";

interface BaseAvailabilityCalendarCellProps extends CalendarCellProps {
  date: Date;
  isSelected: boolean;
  isDisabled: boolean;
  isLoading: boolean;
}

function BaseAvailabilityCalendarCell(
  props: BaseAvailabilityCalendarCellProps,
  ref: ForwardedRef<HTMLButtonElement>
) {
  const { date, isSelected, isDisabled, isLoading, sx, ...restProps } = props;

  return (
    <CalendarCell
      ref={ref}
      date={date}
      disabled={isDisabled}
      isSelected={isSelected}
      isLoading={isLoading}
      sx={mergeSxProps(
        (theme) => ({
          backgroundColor: theme.palette.background.tertiary,
        }),
        sx
      )}
      {...restProps}
    >
      <Box
        sx={{ paddingY: 0.5, textAlign: "center" }}
        aria-selected={isSelected}
        aria-label={format(date, "yyyy-MM-dd")}
      >
        {isSelected && (
          <CbhIcon
            size="small"
            type="dot"
            sx={(theme) => ({
              color: theme.palette.info.main,
            })}
          />
        )}
      </Box>
    </CalendarCell>
  );
}

export const AvailabilityCalendarCell = forwardRef(BaseAvailabilityCalendarCell);
